// extracted by mini-css-extract-plugin
export default {"footer":"_1OyAW _1brkc","selectedMods":"_3H-jl ne2zB","submitButton":"_2KjWx dim-button"};